package com.anjuros.website.templates.template1.modules


import com.anjuros.website.templates.template1.util.ResKey

enum class Template1Price(

    val title: ResKey,
    val price: String

) {

    SERVICE1(
        ResKey.TEMPLATE1_PRICE1_TITLE,
        "£38"
    ),

    SERVICE2(
        ResKey.TEMPLATE1_PRICE2_TITLE,
        "£25"
    ),

    SERVICE3(
        ResKey.TEMPLATE1_PRICE3_TITLE,
        "£65"
    ),

    SERVICE4(
        ResKey.TEMPLATE1_PRICE4_TITLE,
        "From £95"
    ),

    SERVICE5(
        ResKey.TEMPLATE1_PRICE5_TITLE,
        "From £85"
    ),

    SERVICE6(
        ResKey.TEMPLATE1_PRICE6_TITLE,
        "From £120"
    )

}

